import { casingUtil } from '@/utils'
import { InvestmentChat, ServerInvestmentChat } from './types'

export const resolveInvestmentChatDown = (messages: ServerInvestmentChat[]) => {
  return messages.map(casingUtil.snakeToCamel) as InvestmentChat[]
}
